import React from 'react';
import classNames from 'classnames';
import IconButtonGroup from '../icon-button-group';
import Paragraph from '../paragraph';
import { APPEARANCES } from '../paragraph/constants';

function ColorScheme({
  isDarkTheme = false,
  editTooltipLabel = '',
  deleteTooltipLabel = '',
  resetTooltipLabel = '',
  designTooltipLabel = '',
  onDeleteClick = undefined,
  onResetClick = undefined,
  onEditClick,
  title,
  backgroundColor = '',
  onDesignConfigure = undefined,
}) {
  const classes = classNames('ws-ui-color-scheme', {
    'ws-ui-color-scheme--dark': isDarkTheme,
  });
  const defaultActionProps = {
    appearance: isDarkTheme ? 'dark' : 'light',
    size: 'small',
    transparent: true,
  };

  const actions = [
    Boolean(onDesignConfigure) && {
      ...defaultActionProps,
      glyph: 'design',
      label: designTooltipLabel,
      onClick: onDesignConfigure,
    },
    Boolean(onResetClick) && {
      ...defaultActionProps,
      glyph: 'reset',
      label: resetTooltipLabel,
      onClick: onResetClick,
    },
    {
      ...defaultActionProps,
      glyph: 'settings',
      label: editTooltipLabel,
      onClick: onEditClick,
    },
    Boolean(onDeleteClick) && {
      ...defaultActionProps,
      glyph: 'trash',
      label: deleteTooltipLabel,
      onClick: onDeleteClick,
    },
  ].filter(Boolean);

  return (
    <div className={classes} onClick={onEditClick} style={{ background: backgroundColor }}>
      <Paragraph
        size="large"
        appearance={isDarkTheme ? APPEARANCES.white : APPEARANCES.highEmphasis}
      >
        <b>Aa</b>
      </Paragraph>
      <div className="ws-ui-color-scheme__container">
        <Paragraph
          appearance={isDarkTheme ? APPEARANCES.white : APPEARANCES.highEmphasis}
          isClipped
        >
          <b>{title}</b>
        </Paragraph>
        <div className="ws-ui-color-scheme__icon-button-group">
          <IconButtonGroup actions={actions} />
        </div>
      </div>
    </div>
  );
}

export default ColorScheme;
